import {
  createStyles,
  type Theme,
  type WithStyles,
  withStyles,
} from "@material-ui/core/styles";
import { useTranslations } from "adapters/i18n";
import React from "react";

type FarmActionsProps = {
  isEditing: boolean;
  onCancel: () => void;
  onSubmit: () => void;
} & WithStyles<typeof styles>;

function FarmActions({
  classes,
  isEditing,
  onSubmit,
  onCancel,
}: FarmActionsProps) {
  const { t } = useTranslations();

  const saveBtnLabel = isEditing
    ? t("common:actions.save-edit")
    : t("user:save-user");

  return (
    <div className={classes.container}>
      <button
        className={classes.cancelButton}
        data-testid="cancel-button"
        type="button"
        onClick={onCancel}
      >
        <span>{t("common:actions.cancel")}</span>
      </button>
      <button
        className={classes.submitButton}
        data-testid="save-button"
        type="button"
        onClick={onSubmit}
      >
        <span>{saveBtnLabel}</span>
      </button>
    </div>
  );
}

const styles = (theme: Theme) =>
  createStyles({
    container: {
      marginTop: "40px",
      display: "flex",
      justifyContent: "flex-end",
      gap: "16px",
      "& span": {
        fontFamily: "Roboto",
        fontSize: "14px",
        fontWeight: 500,
      },
    },
    cancelButton: {
      backgroundColor: "#fff",
      border: "none",
      color: "#333333",
      padding: "12px 16px",
      cursor: "pointer",
    },
    submitButton: {
      backgroundColor: theme.palette.primary.main,
      border: "none",
      borderRadius: "18px",
      color: "#fff",
      padding: "12px 16px",
      cursor: "pointer",
    },
  });

export default withStyles(styles)(FarmActions);
